import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Dimmer } from "../spinner";
import {
  validaSoloNumero,
  validaNumeroTelefono,
  validaEmail,
} from "../../util/varios";
import CatalogoPersona from "../../catalogos/catalogoPersona";
import { Mensaje } from "../../components/mensajes";
import moment from "moment";

export const Organizacion = (props) => {
  const btnAcepta = useRef();
  const [activate, setActivate] = useState(false);
  const [deshabilitado, setDeshabilitado] = useState(false);
  const [habilitadoNC, setHabilitadoNC] = useState("disabled");
  const [habilitadoNU, setHabilitadoNU] = useState(false);
  const [habilitadoBot, setHabilitadoBot] = useState(false);
  const [ciudad, setCiudad] = useState();
  const [municipio, setMunicipio] = useState();
  const [estado, setEstado] = useState();
  const [mostrar3, setMostrar3] = useState(false);
  const [operacionPer, setOperacionPer] = useState(0);
  const [tecla, setTecla] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [fechaSistema, setFechaSistema] = useState(
    localStorage.getItem("fechasistema")
  );
  /* bloquear tab */
  const [tabIndex, setTabIndex] = useState({
    tab1: "tab",
    tab2: "",
  });
  /* activar tab */
  const [activeTab, setACtiveTab] = useState({
    tab1: "nav-link active",
    tab2: "nav-link",
  });
  /* mostar tabPanel */
  const [tabPanel, setTabPanel] = useState({
    tab1: "tab-pane fade show active",
    tab2: "tab-pane fade",
  });
  /* validar tab */
  const [tabvalid, setTabValid] = useState({
    tab1: "true",
    tab2: "false",
  });
  const [mostrarTab, setMostrarTab] = useState("true");
  const [organizacion, setOrganizacion] = useState("nav-link");
  const [persona, setPersona] = useState({
    cedula: "",
    nombres: "",
    apellidos: "",
    direccion: "",
    correoe: "",
    tlf1: "",
    tlf2: "",
    fnacimiento: "",
    nacionalidad: "",
    sexo: "",
  });

  const txtIdOrg = useRef();
  const txtRazonSoc = useRef();
  const txtNomOrg = useRef();
  const cmbRif = useRef();
  const txtRif = useRef();
  const txtDomicilio = useRef();
  const cmbEstado = useRef();
  const cmbMunicipio = useRef();
  const cmbCiudad = useRef();
  const txtEmailOrg = useRef();
  const txtTlfOrg = useRef();
  const txtCelOrg = useRef();
  const txtFaxOrg = useRef();
  const txtPagWeb = useRef();
  const txtMision = useRef();
  const txtPrincipios = useRef();
  const txtVision = useRef();
  const txtCedula = useRef();
  const txtNombreRespon = useRef();
  const txtApellidoRespon = useRef();
  const txtDireccionRespon = useRef();
  const txtEmailRespon = useRef();
  const txtTlfRespon = useRef();
  const txtCelRespon = useRef();
  const txtFechaNac = useRef();
  const cmbNacionalidad = useRef();
  const cmbSexo = useRef();

  let op = require("../../../public/modulos/datos");
  const token = JSON.parse(localStorage.getItem("jwtToken"));

  useEffect(() => {
    let obj = JSON.parse(localStorage.getItem("post"));
    setFechaSistema(moment(obj.fechasistema).format("YYYY-MM-DD"));
    setDeshabilitado(true);
    CatalogoEstado();
  }, []);

  const validarRif = (event) => {
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setActivate(true);
        let endpoint = op.seniat + "/rif=" + cmbRif + txtRif.current.value;
        axios
          .get(endpoint)
          .then(function (response) {
            if (response.status == 200) {
              response.data.rif === "error de conexion al seniat"
                ? (setMensaje({
                    mostrar: true,
                    titulo: "Notificacion",
                    texto: "Error interno de Conexión",
                    icono: "informacion",
                  }),
                  txtDomicilio.current.focus())
                : ((txtRif.current.value = response.data.rif),
                  setHabilitadoNC("disabled"));
            }
          })
          .catch(function (err) {
            if (err) {
              txtDomicilio.current.focus();
            }
          })
          .then(function () {
            setActivate(false);
          });
      } else {
      }
    }
  };

  const CatalogoEstado = () => {
    let endpoint = `${op.conexion}/api/catalogo/estado`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setEstado(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarCiudad = (id, idciu) => {
    let campos = "*";
    let nomtab = "ciudad";
    let nomid = "idmunicipio";
    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setCiudad(response.data);
            cmbCiudad.current.value = idciu;
            seleccionarMunicipio(cmbEstado.current.value, id);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarMunicipio = (id, idmun) => {
    setActivate(true);
    let campos = "*";
    let nomtab = "municipio";
    let nomid = "idestado";

    let endpoint = `${op.conexion}/api/consulta/modelirows?campos=${campos}&id=${id}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.length > 0) {
            setMunicipio(response.data);
            cmbMunicipio.current.value = idmun;
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const editarOrganizacion = () => (event) => {
    event.preventDefault();
    setTabIndex({ ...tabIndex, tab2: "tab" });
    setActivate(true);
    seleccionarOrganizacion();
  };

  const seleccionarOrganizacion = () => {
    setActivate(true);
    let endpoint = `${op.conexion}/api/comun/organizacion`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then((response) => {
        if (response.status == 200) {
          if (response.data.idorganizacion > 0) {
            setDeshabilitado(false);
            setHabilitadoBot(true);
            setHabilitadoNU(false);
            txtIdOrg.current.value = response.data.idorganizacion;
            txtRazonSoc.current.value = response.data.razonsocial.trim();
            txtNomOrg.current.value = response.data.nombre.trim();
            txtDomicilio.current.value = response.data.domicilio.trim();
            cmbRif.current.value = isNaN(response.data.rif.substring(0, 1))
              ? response.data.rif.substring(0, 1)
              : "";
            txtRif.current.value = isNaN(response.data.rif.substring(0, 1))
              ? response.data.rif.substring(1, response.data.rif.trim().length)
              : !isNaN(response.data.rif.substring(0, 1))
              ? response.data.rif.substring(0, response.data.rif.trim().length)
              : "";
            txtEmailOrg.current.value =
              response.data.correoe === null
                ? response.data.correoe
                : response.data.correoe.trim();
            txtTlfOrg.current.value =
              response.data.tlf1 === null
                ? response.data.tlf1
                : response.data.tlf1.trim();
            txtCelOrg.current.value =
              response.data.tlf2 === null
                ? response.data.tlf2
                : response.data.tlf2.trim();
            txtFaxOrg.current.value =
              response.data.fax === null
                ? response.data.fax
                : response.data.fax.trim();
            txtPagWeb.current.value =
              response.data.pagweb === null
                ? response.data.pagweb
                : response.data.pagweb.trim();
            txtMision.current.value =
              response.data.mision === null
                ? response.data.mision
                : response.data.mision.trim();
            txtPrincipios.current.value =
              response.data.principios === null
                ? response.data.principios
                : response.data.principios.trim();
            txtVision.current.value =
              response.data.vision === null
                ? response.data.vision
                : response.data.vision.trim();
            cmbCiudad.current.value = response.data.idciudad;
            cmbMunicipio.current.value = response.data.idmunicipio;
            cmbEstado.current.value = response.data.idestado;
            txtCedula.current.value = response.data.cedularesponsable;
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            seleccionarCiudad(
              response.data.idmunicipio,
              response.data.idciudad
            );

            setActivate(false);
          } else {
          }
        }

        setActivate(false);
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const cancelar = () => (event) => {
    setTabIndex({ tab1: "tab", tab2: "" });
    event.preventDefault();
    blanquear();
  };

  const blanquear = () => {
    txtIdOrg.current.value = "";
    txtRazonSoc.current.value = "";
    txtNomOrg.current.value = "";
    txtDomicilio.current.value = "";
    cmbRif.current.value = "";
    txtRif.current.value = "";
    txtEmailOrg.current.value = "";
    txtTlfOrg.current.value = "";
    txtCelOrg.current.value = "";
    txtFaxOrg.current.value = "";
    txtPagWeb.current.value = "";
    txtMision.current.value = "";
    txtPrincipios.current.value = "";
    txtVision.current.value = "";
    cmbCiudad.current.value = "";
    cmbMunicipio.current.value = "";
    cmbEstado.current.value = "";
    txtCedula.current.value = "";
    txtNombreRespon.current.value = "";
    txtApellidoRespon.current.value = "";
    txtDireccionRespon.current.value = "";
    txtEmailRespon.current.value = "";
    txtTlfRespon.current.value = "";
    txtCelRespon.current.value = "";
    txtFechaNac.current.value = "";
    cmbNacionalidad.current.value = "";
    cmbSexo.current.value = "";
    setMunicipio();
    setCiudad();
    cmbEstado.current.value = "";
    setDeshabilitado(true);
    setHabilitadoBot(false);
  };

  const onChange = (event) => {
    if (event.target.name === "idestado") {
      cmbEstado.current.value = event.target.value;
      setMunicipio();
      setCiudad();

      if (event.target.value !== "") {
        seleccionarMunicipio(event.target.value, "");
      }
    } else if (event.target.name === "idmunicipio") {
      cmbMunicipio.current.value = event.target.value;
      setCiudad();

      if (event.target.value !== "") {
        seleccionarCiudad(event.target.value, "");
      }
    } else if (event.target.name === "idciudad") {
      cmbCiudad.current.value = event.target.value;
    }
  };

  const handleCloseCatalogoPer = () => {
    setMostrar3(false);
  };

  const handleAceptaCatalogoPer = (
    cedPer,
    nomPer,
    apePer,
    correoPer,
    tlf1Per,
    tlf2Per,
    fnacPer,
    nacPer,
    sexoPer,
    direPer
  ) => {
    setMostrar3(false);
    txtCedula.current.value = cedPer;
    txtNombreRespon.current.value = nomPer;
    txtApellidoRespon.current.value = apePer;
    txtDireccionRespon.current.value = direPer;
    txtEmailRespon.current.value = correoPer;
    txtTlfRespon.current.value = tlf1Per;
    txtCelRespon.current.value = tlf2Per;
    txtFechaNac.current.value = moment(fnacPer).format("YYYY-MM-DD");
    cmbNacionalidad.current.value = nacPer;
    cmbSexo.current.value = sexoPer;
  };

  const catalogoPer = (e) => {
    e.preventDefault();
    setMostrar3(true);
  };

  const validarPersona = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        setTecla(event.which);
        datosRes(event.target.value);
      } else {
        txtNombreRespon.current.value = "";
      }
    }
  };

  const datosRes = (cedula) => {
    let campos = "*";
    let nomtab = "persona";
    let nomid = "cedula";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${cedula}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setHabilitadoNU(true);
          txtNombreRespon.current.value = "";
          txtApellidoRespon.current.value = "";
          txtDireccionRespon.current.value = "";
          txtEmailRespon.current.value = "";
          txtTlfRespon.current.value = "";
          txtCelRespon.current.value = "";
          txtFechaNac.current.value = "";
          cmbNacionalidad.current.value = "V";
          cmbSexo.current.value = "M";
          if (response.data !== "") {
            setHabilitadoNU(false);
            setOperacionPer(0);
            txtNombreRespon.current.value = response.data.nombres;
            txtApellidoRespon.current.value = response.data.apellidos;
            txtDireccionRespon.current.value = response.data.direccion;
            txtEmailRespon.current.value = response.data.correoe;
            txtTlfRespon.current.value = response.data.tlf1;
            txtCelRespon.current.value = response.data.tlf2;
            txtFechaNac.current.value = moment(
              response.data.fnacimiento
            ).format("YYYY-MM-DD");
            cmbNacionalidad.current.value = response.data.nacionalidad;
            cmbSexo.current.value = response.data.sexo;
            if (tecla === 13) {
              btnAcepta.current.focus();
            }
          } else {
            setOperacionPer(1);
            setHabilitadoNU(true);
            if (tecla === 13) {
              setTimeout(() => {
                txtNombreRespon.current.focus();
              }, 100);
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const handleInputChange = (event) => {
    if (event.which === 13) {
      var valido;
      if (event.target.id === "inputRazonSoc") {
        txtNomOrg.current.focus();
      } else if (event.target.id === "inputNombre") {
        cmbRif.current.focus();
      } else if (event.target.id === "inputRif") {
        txtDomicilio.current.focus();
      } else if (event.target.id === "inputDomicilio") {
        cmbEstado.current.focus();
      } else if (event.target.id === "inputEmailOrg") {
        txtTlfOrg.current.focus();
      } else if (event.target.id === "inputTlfOrg") {
        txtCelOrg.current.focus();
      } else if (event.target.id === "inputCelOrg") {
        txtFaxOrg.current.focus();
      } else if (event.target.id === "inputFaxOrg") {
        txtPagWeb.current.focus();
      } else if (event.target.id === "inputPagWeb") {
        txtMision.current.focus();
      } else if (event.target.id === "inputMision") {
        txtPrincipios.current.focus();
      } else if (event.target.id === "inputPrincipios") {
        txtVision.current.focus();
      } else if (event.target.id === "inputVision") {
        txtCedula.current.focus();
      } else if (event.target.id === "inputNombreRespon") {
        txtApellidoRespon.current.focus();
      } else if (event.target.id === "inputApellidoRespon") {
        txtDireccionRespon.current.focus();
      } else if (event.target.id === "inputEmailRespon") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            setMensaje({
              mostrar: true,
              titulo: "Notificacion",
              texto: "Formato de Email invalido.",
              icono: "informacion",
            });
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfRespon") {
        txtCelRespon.current.focus();
      } else if (event.target.id === "inputCelRespon") {
        txtFechaNac.current.focus();
      } else if (event.target.id === "inputFechaNac") {
        cmbNacionalidad.current.focus();
      }
    } else if (typeof event.which === "undefined") {
      if (event.target.id === "inputEmailOrg") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfOrg.current.focus();
        } else {
          if (event.target.value !== "") {
            event.target.value = "";
          } else {
            txtTlfOrg.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfOrg") {
        txtCelOrg.current.focus();
      } else if (event.target.id === "inputCelOrg") {
        txtFaxOrg.current.focus();
      } else if (event.target.id === "inputEmailRespon") {
        valido = validaEmail(event.target.value);
        if (valido) {
          txtTlfRespon.current.focus();
        } else {
          if (event.target.value !== "") {
            event.target.value = "";
          } else {
            txtTlfRespon.current.focus();
          }
        }
      } else if (event.target.id === "inputTlfRespon") {
        txtCelRespon.current.focus();
      } else if (event.target.id === "inputCelRespon") {
        txtFechaNac.current.focus();
      } else {
        return false;
      }
    } else if (event.which === 46) {
      return false;
    } else if (event.which >= 48 && event.which <= 57) {
      return true;
    } else if (event.which === 8 || event.which === 0 || event.which === 44) {
      return true;
    } else return false;
  };

  const onChangeValidar = (e) => {
    e.preventDefault();
    var sigue = true;
    var mensaje = "";
    if (txtRazonSoc.current.value.trim() === "") {
      sigue = false;
      mensaje = "La Razon Social no debe estar vacia";
      setTabIndex(0);
      txtRazonSoc.current.focus();
    } else if (txtNomOrg.current.value.trim() === "") {
      mensaje = "El Nombre de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtNomOrg.current.focus();
    } else if (txtRif.current.value.trim() === "") {
      mensaje = "El Rif de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtRif.current.focus();
    } else if (txtDomicilio.current.value.trim() === "") {
      mensaje = "El Domicilio de la Organizacion no debe estar vacio";
      sigue = false;
      setTabIndex(0);
      txtDomicilio.current.focus();
    } else if (cmbEstado.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione el Estado";
      sigue = false;
      setTabIndex(0);
      cmbEstado.current.focus();
    } else if (cmbMunicipio.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione el Municipio";
      sigue = false;
      setTabIndex(0);
      cmbMunicipio.current.focus();
    } else if (cmbCiudad.current.value.trim() === "") {
      mensaje = "Por Favor Seleccione la Ciudad";
      sigue = false;
      setTabIndex(0);
      cmbCiudad.current.focus();
    } else if (txtCedula.current.value.trim() === "") {
      mensaje = "La cedula no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "tab", ...tabIndex });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
      txtCedula.current.focus();
    } else if (txtNombreRespon.current.value.trim() === "") {
      mensaje = "Los nombres no deben estar vacios";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
      txtNombreRespon.current.focus();
    } else if (txtApellidoRespon.current.value.trim() === "") {
      mensaje = "Los Apellidos no deben estar vacio";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtApellidoRespon.current.focus();
    } else if (txtDireccionRespon.current.value.trim() === "") {
      mensaje = "La direccion del Responsable no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtDireccionRespon.current.focus();
    } else if (txtFechaNac.current.value.trim() === "") {
      mensaje = "La fecha de nacimiento no debe estar vacia";
      sigue = false;
      setTabIndex({ tab1: "", tab2: "tab" });
      setTabIndex({ tab1: "tab", ...tabIndex });
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });

      setTabIndex(1);
      txtFechaNac.current.focus();
    }

    if (sigue) {
      var org = [];
      var datoPer = [];

      org.push({
        idorganizacion: txtIdOrg.current.value,
        ciudad: cmbCiudad.current.value,
        nombre: txtNomOrg.current.value,
        domicilio: txtDomicilio.current.value,
        tlf1: txtTlfOrg.current.value,
        tlf2: txtCelOrg.current.value,
        fax: txtFaxOrg.current.value,
        correoe: txtEmailOrg.current.value,
        mision: txtMision.current.value,
        principios: txtPrincipios.current.value,
        vision: txtVision.current.value,
        pagweb: txtPagWeb.current.value,
        rif: cmbRif.current.value + txtRif.current.value,
        cedularesponsable: txtCedula.current.value,
        razonsocial: txtRazonSoc.current.value,
      });
      datoPer.push({
        apellidos: txtApellidoRespon.current.value.trim(),
        cedula: txtCedula.current.value,
        correoe: txtEmailRespon.current.value,
        direccion: txtDireccionRespon.current.value.trim(),
        fnacimiento: txtFechaNac.current.value,
        nacionalidad: cmbNacionalidad.current.value,
        nombres: txtNombreRespon.current.value.trim(),
        sexo: cmbSexo.current.value,
        tlf1: txtTlfRespon.current.value,
        tlf2: txtCelRespon.current.value,
      });
      setOrganizacion(org);
      setPersona(datoPer);
      setActivate(true);
      let body = {
        operacionper: operacionPer,
        org: JSON.stringify(org),
        perso: JSON.stringify(datoPer),
      };
      procesarRegistro(body);
    } else {
      setMensaje({
        mostrar: true,
        titulo: "Notificacion",
        texto: mensaje,
        icono: "informacion",
      });
      setTimeout(() => {
        txtNombreRespon.current.focus();
      }, 500);
    }
  };

  const procesarRegistro = (body) => {
    let endpoint = `${op.conexion}/api/comun/actualizarorganizacion`;

    axios
      .post(endpoint, body, {
        headers: {
          "x-access-token": `${token}`,
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          setActivate(false);
          setMensaje({
            mostrar: true,
            titulo: "Editar Organizacion",
            texto:
              "La Organizacion " +
              txtIdOrg.current.value +
              " ha sido actualizada de manera satisfactoria.",
            icono: "informacion",
          });
          blanquear();
        }
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const tabs = (vl) => (e) => {
    e.preventDefault();

    if (vl === 2) {
      setACtiveTab({ tab1: "nav-link", tab2: "nav-link active" });
      setTabValid({ tab1: "false", tab2: "true" });
      setTabPanel({ tab1: "tab-pane fade", tab2: "tab-pane fade show active" });
    } else {
      setACtiveTab({ tab1: "nav-link active", tab2: "nav-link " });
      setTabValid({ tab1: "true", tab2: "false" });
      setTabPanel({
        tab1: "tab-pane fade show active",
        tab2: "tab-pane fade ",
      });
    }
  };

  return (
    <div>
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <Dimmer active={activate} />
      <CatalogoPersona
        titulo={""}
        mensaje={""}
        show={mostrar3}
        onHideCancelaCatPer={handleCloseCatalogoPer}
        onHideAceptaCatPer={handleAceptaCatalogoPer}
      />
      <div>
        <ul className="nav nav-tabs mb-3" id="ex-with-icons" role="tablist">
          <li className="nav-item" role="presentation">
            <a
              className={activeTab.tab1}
              id="ex-with-icons-tab-1"
              style={{ backgroundColor: "#25d366" }}
              onClick={tabs(1)}
              data-mdb-toggle={tabIndex.tab1}
              href="#tab1"
              role="tab"
              aria-controls="tab1"
              aria-selected={tabvalid.tab1}
            >
              <i className="fas fa-chart-pie fa-fw me-2" />
              Datos Gnr.
            </a>
          </li>
          <li className="nav-item" role="presentation">
            <a
              className={activeTab.tab2}
              id="ex-with-icons-tab-2"
              style={{ backgroundColor: "#55acee" }}
              onClick={tabs(2)}
              data-mdb-toggle={tabIndex.tab2}
              href="#tab2"
              role="tab"
              aria-controls="tab2"
              aria-selected={tabvalid.tab2}
            >
              <i className="fas fa-chart-line fa-fw me-2" />
              Responsable
            </a>
          </li>
        </ul>
        <div className="tab-content" id="ex-with-icons-content">
          <div
            className={tabPanel.tab1}
            id="tab1"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-1"
          >
            <div className="container-fluid row bg-light h-100 py-4 px-4 rounded mx-auto">
              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Codigo:
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled
                  ref={txtIdOrg}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-9">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Razon Social:
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled={deshabilitado}
                  autoComplete="off"
                  ref={txtRazonSoc}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputRazonSoc"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
              <div className="input-group py-1 input-group-sm col-sm-9">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Nombre:
                </label>
                <input
                  type="text"
                  className="form-control"
                  disabled={deshabilitado}
                  autoComplete="off"
                  ref={txtNomOrg}
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputNombre"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
              <div className="input-group py-1 input-group-sm col-sm-1">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Rif:
                </label>
                <select
                  disabled={deshabilitado}
                  ref={cmbRif}
                  className="form-control form-control-sm"
                  id="inputLetraRif"
                  onKeyUp={validarRif}
                  onBlur={validarRif}
                >
                  <option value="J">J</option>
                  <option value="V">V</option>
                  <option value="G">G</option>
                  <option value="E">E</option>
                  <option value="P">P</option>
                </select>
              </div>
              <div className="input-group py-1 input-group-sm col-sm-2">
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtRif}
                  maxLength={14}
                  className="form-control form-control-sm"
                  placeholder="123456789"
                  id="inputRif"
                  /*onKeyUp={validarRif} onBlur={validarRif}*/ onKeyUp={
                    handleInputChange
                  }
                  onBlur={handleInputChange}
                />
              </div>
              <div className="input-group py-1 input-group-sm col-sm-12">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Domicilio:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtDomicilio}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputDomicilio"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Estado:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="idestado"
                  disabled={deshabilitado}
                  ref={cmbEstado}
                  /*value={valuest && valuest.idestado}*/ onChange={onChange}
                  id="inputFechaReg"
                >
                  <option value={""}>SELECCIONAR ESTADO</option>
                  {estado &&
                    estado.map((item, index) => (
                      <option key={index} value={item.idestado}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Municipio:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="idmunicipio"
                  disabled={deshabilitado}
                  ref={cmbMunicipio}
                  /*value={valuest && valuest.idmunicipio}*/ onChange={onChange}
                >
                  <option value={""}>SELECCIONAR MUNICIPIO</option>
                  {municipio &&
                    municipio.map((item, index) => (
                      <option key={index} value={item.idmunicipio}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Ciudad:
                </label>
                <select
                  className="form-select"
                  aria-label="Default select example col-md-4"
                  name="idciudad"
                  disabled={deshabilitado}
                  ref={cmbCiudad}
                  /*value={valuest && valuest.idciudad}*/ onChange={onChange}
                >
                  <option value={""}>SELECCIONAR CIUDAD</option>
                  {ciudad &&
                    ciudad.map((item, index) => (
                      <option key={index} value={item.idciudad}>
                        {" "}
                        {item.nombre}{" "}
                      </option>
                    ))}
                </select>
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  E-mail:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtEmailOrg}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputEmailOrg"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Telefono:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtTlfOrg}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputTlfOrg"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Celular:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtCelOrg}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputCelOrg"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Fax:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtFaxOrg}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputFaxOrg"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-5">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Página Web:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtPagWeb}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputPagWeb"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-5">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Misión:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtMision}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputMision"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
              <div className="input-group py-1 input-group-sm col-sm-6">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Principios:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtPrincipios}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputPrincipios"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>
              <div className="input-group py-1 input-group-sm col-sm-6">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Visión:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  ref={txtVision}
                  autoComplete="off"
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputVision"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="col-sm-12 d-flex justify-content-end row mx-auto py-3">
                <button
                  type="button"
                  disabled={habilitadoBot}
                  style={{ margin: "1px" }}
                  onClick={editarOrganizacion()}
                  className="col-sm-2 btn btn-sm btn-primary rounded-pill"
                >
                  <i className="fas fa-pen-nib"></i>Modificar
                </button>

                <button
                  type="button"
                  disabled={!habilitadoBot}
                  style={{ margin: "1px" }}
                  onClick={onChangeValidar}
                  ref={btnAcepta}
                  className="col-sm-2  btn-sm btn btn-success rounded-pill"
                >
                  <i className="far fa-check-circle"></i>Aceptar
                </button>

                <button
                  type="button"
                  disabled={!habilitadoBot}
                  style={{ margin: "1px" }}
                  onClick={cancelar()}
                  className="col-sm-2 btn btn-sm btn-danger rounded-pill"
                >
                  <i className="far fa-times-circle"></i>Cancelar
                </button>
              </div>
            </div>
          </div>

          <div
            className={tabPanel.tab2}
            id="tab2"
            role="tabpanel"
            aria-labelledby="ex-with-icons-tab-2"
          >
            <div className="container-fluid row bg-light h-100 py-4 px-4 rounded mx-auto">
              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Cedula:
                </label>
                <input
                  type="text"
                  disabled={deshabilitado}
                  autoComplete="off"
                  ref={txtCedula}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  onKeyUp={validarPersona}
                  onBlur={validarPersona}
                />
                <button
                  type="button"
                  disabled={deshabilitado}
                  onClick={catalogoPer}
                  className="btn btn-success"
                  id="inputGroup-sizing-sm"
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>

              <div className="col-sm-6"></div>

              <div className="input-group py-1 input-group-sm col-sm-5">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Nombres:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtNombreRespon}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputNombreRespon"
                  name="inputNombreRespon"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-5">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Apellidos:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtApellidoRespon}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputApellidoRespon"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-10">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Direccion:
                </label>
                <textarea
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtDireccionRespon}
                  className="form-control"
                  id="textAreaExample"
                  rows="3"
                ></textarea>
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  E-mail:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtEmailRespon}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputEmailRespon"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Telefono:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtTlfRespon}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputTlfRespon"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-3">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Celular:
                </label>
                <input
                  type="text"
                  disabled={!habilitadoNU}
                  autoComplete="off"
                  ref={txtCelRespon}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputCelRespon"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Fecha Namiento:
                </label>
                <input
                  type="date"
                  disabled={!habilitadoNU}
                  ref={txtFechaNac}
                  max={fechaSistema}
                  className="form-control"
                  aria-label="Sizing example input"
                  aria-describedby="inputGroup-sizing-sm"
                  id="inputFechaNac"
                  onKeyUp={handleInputChange}
                  onBlur={handleInputChange}
                />
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Nacionalidad:
                </label>
                <select
                  disabled={!habilitadoNU}
                  ref={cmbNacionalidad}
                  className="form-select"
                  aria-label="Default select example "
                >
                  <option key="0" value="V">
                    V
                  </option>
                  <option key="1" value="E">
                    E
                  </option>
                </select>
              </div>

              <div className="input-group py-1 input-group-sm col-sm-4">
                <label className="input-group-text" id="inputGroup-sizing-sm">
                  Sexo:
                </label>
                <select
                  disabled={!habilitadoNU}
                  ref={cmbSexo}
                  className="form-select"
                  aria-label="Default select example "
                >
                  <option key="0" value="M">
                    M
                  </option>
                  <option key="1" value="F">
                    F
                  </option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/configuracionGeneral/organizacion.js